import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

interface EmptyProps {
  className?: string;
  message?: string;
}

const Empty: React.FC<EmptyProps> = ({
  className = '',
  message = "Sorry, we couldn't find anything",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center pointer-events-none ${className}`}
    >
      <div className="flex justify-center w-full">
        <div className="md:w-[356px] w-[256px]">
          <DotLottieReact
            src={`${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/assets/animations/Searching.lottie`}
            loop
            autoplay
            style={{ height: '100%', width: '100%' }}
          />
        </div>
      </div>
      <div className="text-center w-full px-4">
        <h3 className="text-lg font-medium text-gray-900">Sorry, we couldn't find anything</h3>
        <p className="mt-2 text-gray-500">
          {message ||
            'Try searching for something else or adjusting your filters'}
        </p>
      </div>
    </div>
  );
};

export default Empty;